import { render, staticRenderFns } from "./RowDetail.vue?vue&type=template&id=158d0e52"
import script from "./RowDetail.vue?vue&type=script&lang=js"
export * from "./RowDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('158d0e52')) {
      api.createRecord('158d0e52', component.options)
    } else {
      api.reload('158d0e52', component.options)
    }
    module.hot.accept("./RowDetail.vue?vue&type=template&id=158d0e52", function () {
      api.rerender('158d0e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/loadingProcess/components/RowDetail.vue"
export default component.exports